var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-body" },
    [
      _c(
        "div",
        { staticClass: "opt-btn" },
        [
          _vm.hasBtnPermission("btn_supervise_reply")
            ? _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-plus",
                  },
                  on: { click: _vm.batchReplyHandler },
                },
                [_vm._v("批量回复")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dataListLoading,
              expression: "dataListLoading",
            },
          ],
          ref: "multipleTable",
          staticClass: "table-content",
          attrs: {
            data: _vm.replyList,
            "row-key": "id",
            "header-cell-style": this.$globalGrayTableHeaderStyle,
            stripe: "",
            border: "",
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "filter-change": _vm.filterChange,
            "sort-change": _vm.sortChange,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              type: "index",
              align: "center",
              label: "序号",
              width: "60",
              index: _vm.getRowsIndex,
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              type: "selection",
              align: "center",
              "reserve-selection": true,
              selectable: _vm.selected,
            },
          }),
          _c("el-table-column", {
            attrs: {
              "column-key": "receiveStatusCondition",
              label: "接收状态",
              prop: "receiveStatus",
              align: "center",
              width: "90px",
              "show-overflow-tooltip": true,
              filters: [
                { text: "待接收", value: 0 },
                { text: "已接收", value: 1 },
                { text: "已失效", value: 2 },
              ],
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("i", {
                      class: _vm.formatterStatusClass(scope.row.receiveStatus),
                    }),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.formatterStatusName(scope.row.receiveStatus))
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "回复状态",
              prop: "takeReplyStatus",
              align: "center",
              width: "100",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.takeReplyStatus == "部分回复"
                      ? _c("el-tag", [
                          _vm._v(_vm._s(scope.row.takeReplyStatus)),
                        ])
                      : scope.row.takeReplyStatus == 1
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("已回复"),
                        ])
                      : _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v("未回复"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "督办标题",
              prop: "title",
              "header-align": "center",
              align: "left",
              "min-width": "200",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "custom-header" },
                      [
                        _c("span", [_vm._v("督办标题")]),
                        _c(
                          "el-popover",
                          { attrs: { width: "300", trigger: "click" } },
                          [
                            _c(
                              "div",
                              { staticClass: "custom-section" },
                              [
                                _c("p", [_vm._v("请输入")]),
                                _c("el-input", {
                                  attrs: { clearable: "" },
                                  model: {
                                    value: _vm.queryData.filter.title,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryData.filter,
                                        "title",
                                        $$v
                                      )
                                    },
                                    expression: "queryData.filter.title",
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "custom-section--btns" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", type: "text" },
                                        on: { click: _vm.cancelFilter },
                                      },
                                      [_vm._v("取消")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                        },
                                        on: { click: _vm.filterHandler },
                                      },
                                      [_vm._v("确定")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("i", {
                              staticClass: "el-icon-search",
                              attrs: { slot: "reference" },
                              slot: "reference",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "row-overflow" }, [
                      _vm._v(_vm._s(scope.row.title)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "督办部门",
              prop: "deptName",
              align: "left",
              width: "150",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "custom-header" },
                      [
                        _c("span", [_vm._v("督办部门")]),
                        _c(
                          "el-popover",
                          { attrs: { width: "300", trigger: "click" } },
                          [
                            _c(
                              "div",
                              { staticClass: "custom-section" },
                              [
                                _c("p", [_vm._v("请输入")]),
                                _c("el-input", {
                                  attrs: { clearable: "" },
                                  model: {
                                    value: _vm.queryData.filter.deptName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryData.filter,
                                        "deptName",
                                        $$v
                                      )
                                    },
                                    expression: "queryData.filter.deptName",
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "custom-section--btns" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", type: "text" },
                                        on: { click: _vm.cancelFilter },
                                      },
                                      [_vm._v("取消")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                        },
                                        on: { click: _vm.filterHandler },
                                      },
                                      [_vm._v("确定")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("i", {
                              staticClass: "el-icon-search",
                              attrs: { slot: "reference" },
                              slot: "reference",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "督办时间",
              prop: "inspectorTime",
              align: "center",
              width: "170",
              "show-overflow-tooltip": true,
              sortable: true,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.formatDate(
                            scope.row.createTime,
                            "yyyy-MM-dd HH:mm:ss"
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "回复时限",
              prop: "timeLimit",
              align: "center",
              width: "150",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.isTimeOut && scope.row.replyStatus == -1
                      ? _c("p", { staticStyle: { margin: "0" } }, [
                          _vm._v(_vm._s(scope.row.limitDays) + " "),
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("（已超时）"),
                          ]),
                        ])
                      : _c("p", { staticStyle: { margin: "0" } }, [
                          _vm._v(_vm._s(scope.row.limitDays)),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "督办对象",
              prop: "inspectorObjects",
              align: "left",
              width: "250",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "custom-header" },
                      [
                        _c("span", [_vm._v("督办对象")]),
                        _c(
                          "el-popover",
                          { attrs: { width: "300", trigger: "click" } },
                          [
                            _c(
                              "div",
                              { staticClass: "custom-section" },
                              [
                                _c("p", [_vm._v("请输入")]),
                                _c("el-input", {
                                  attrs: { clearable: "" },
                                  model: {
                                    value:
                                      _vm.queryData.filter.inspectorObjects,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryData.filter,
                                        "inspectorObjects",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryData.filter.inspectorObjects",
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "custom-section--btns" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", type: "text" },
                                        on: { click: _vm.cancelFilter },
                                      },
                                      [_vm._v("取消")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                        },
                                        on: { click: _vm.filterHandler },
                                      },
                                      [_vm._v("确定")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("i", {
                              staticClass: "el-icon-search",
                              attrs: { slot: "reference" },
                              slot: "reference",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "回复时间",
              prop: "replyTime",
              align: "center",
              width: "170",
              "show-overflow-tooltip": true,
              sortable: true,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.replyTime))])]
                },
              },
            ]),
          }),
          _c(
            "el-table-column",
            {
              attrs: {
                label: "回复内容",
                prop: "replyContent",
                align: "left",
                width: "160",
                "show-overflow-tooltip": true,
              },
            },
            [
              _c("template", { slot: "header" }, [
                _c("div", { staticClass: "custom-header" }, [
                  _c("span", [_vm._v("回复内容")]),
                ]),
              ]),
            ],
            2
          ),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              fixed: "right",
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.receiveStatus != 2,
                            expression: "scope.row.receiveStatus != 2",
                          },
                        ],
                        attrs: { type: "text", size: "small", title: "修改" },
                        on: {
                          click: function ($event) {
                            return _vm.replyHandler(scope.row)
                          },
                        },
                      },
                      [_vm._v("回复")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          background: "",
          layout: "total, sizes, prev, pager, next",
          "page-sizes": [10, 20, 50, 100],
          "page-size": _vm.pageSize,
          total: _vm.total,
          "current-page": _vm.pageIndex,
        },
        on: {
          "size-change": _vm.sizeChangeHandle,
          "current-change": _vm.currentChangeHandle,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "督办回复",
            visible: _vm.replyDialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.replyDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.replyForm,
                rules: _vm.replyRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "回复内容：", prop: "replyContent" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入回复内容",
                      maxlength: 255,
                    },
                    model: {
                      value: _vm.replyForm.replyContent,
                      callback: function ($$v) {
                        _vm.$set(_vm.replyForm, "replyContent", $$v)
                      },
                      expression: "replyForm.replyContent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "回复人员：", prop: "replyUser" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.replyForm.replyUser,
                      callback: function ($$v) {
                        _vm.$set(_vm.replyForm, "replyUser", $$v)
                      },
                      expression: "replyForm.replyUser",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "回复单位：", prop: "replyDeptName" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.replyForm.replyDeptName,
                      callback: function ($$v) {
                        _vm.$set(_vm.replyForm, "replyDeptName", $$v)
                      },
                      expression: "replyForm.replyDeptName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "回复时间：", prop: "replyUser" } },
                [
                  _c("el-input", {
                    attrs: { value: "提交后自动生成", disabled: "" },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "相关附件：" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "",
                        "show-file-list": false,
                        "http-request": _vm.upload,
                        "file-list": _vm.fileList,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "120px" },
                              attrs: { size: "small", type: "primary" },
                            },
                            [_vm._v("点击上传")]
                          ),
                          _c(
                            "ul",
                            _vm._l(_vm.fileList, function (item, index) {
                              return _c("li", { key: index }, [
                                _vm._v(_vm._s(item.name)),
                              ])
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.cancelReply } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.replyConfirm } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }